import { axiosInstance } from "./AxiosDefaults";
import { usersRoute } from "../constants/ApiRoutes";
import { User } from "../models/User";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllUsers = (): Promise<any> => {
  return axiosInstance.get(usersRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneUser = (id: string): Promise<any> => {
  return axiosInstance.get(`${usersRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createUser = (payload: Partial<User>): Promise<any> => {
  return axiosInstance.post(usersRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneUser = (id: string, payload: Partial<User>): Promise<any> => {
  return axiosInstance.put(`${usersRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
